var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLorealCustomerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 32,
    viewBox: "0 0 105 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1297 24.2217H70.6806V22.5665H59.4528V17.27H67.8862V15.5953H59.4528V10.7156H70.6806V9.06641H57.1297V24.2217Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1717 6.61633L62.337 8.67741L68.0964 6.61633H64.1717Z",
    fill: "#B1B1B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4284 22.5665V9.06641H91.3103V24.2217H105.009V22.5665H93.4284Z",
    fill: "#B1B1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4615 9.06641L71.7557 24.2217H74.3604L76.3319 20.2991H85.574L87.5623 24.2217H90.1399L82.4278 9.06641H79.4615ZM77.3073 18.3994L80.9388 11.1606L84.6125 18.3994H77.3073Z",
    fill: "#B1B1B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7765 17.8845C53.2485 16.958 53.5859 14.3747 53.5682 13.4511C53.361 10.7437 51.5368 9.06641 48.2591 9.06641H38.7072V24.2217H40.8846V17.8643H47.1032L51.6781 24.2217H54.4226C54.4225 24.2217 51.1303 19.9431 49.7765 17.8845ZM47.9618 16.0736H40.8846V10.8602H48.2084C49.8946 10.8602 50.8431 11.6474 51.1848 12.6474C51.4108 13.3328 51.266 14.2326 50.892 14.8452C50.2799 15.8581 49.1171 16.0736 47.9618 16.0736Z",
    fill: "#B1B1B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6227 6.50012C19.4759 6.50012 15.2865 10.834 15.2865 16.0795C15.2865 21.6017 19.9144 25.5001 25.6227 25.5001C31.3272 25.5001 35.9533 21.6574 35.9533 16.0795C35.9533 10.834 31.712 6.50012 25.6227 6.50012ZM25.5489 23.6188C21.2963 23.6188 17.7924 20.2014 17.7924 16.0846C17.7924 11.9735 21.1309 8.3924 25.7138 8.3924C30.1832 8.3924 33.4685 11.9735 33.4685 16.0846C33.4685 20.2013 29.7998 23.6188 25.5489 23.6188Z",
    fill: "#B1B1B1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79991 14.4278H11.3711L14.223 9.06641H11.928L9.79991 14.4278Z",
    fill: "#B1B1B1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11924 22.5665V9.06641H7.62939e-06V24.2217H13.6984V22.5665H2.11924Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLorealCustomerLogo);
export default __webpack_public_path__ + "static/media/loreal-customer-logo.ae86dbd61ed9d7c97c20431be098be71.svg";
export { ForwardRef as ReactComponent };